import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { initI18n } from './i18n'
import './styles/index.scss'

import Rollbar from 'rollbar'

// Set the Rollbar instance in the Vue prototype
// before creating the first Vue instance.
// This ensures it is available in the same way for every
// instance in your app.
Vue.prototype.$rollbar = new Rollbar({
  accessToken: '7518fb03c00e4a809e2735afdfa96678',
  captureUncaught: true,
  captureUnhandledRejections: true,
})

// If you have already set up a global error handler,
// just add `vm.$rollbar.error(err)` to the top of it.
// If not, this simple example will preserve the app’s existing
// behavior while also reporting uncaught errors to Rollbar.
// eslint-disable-next-line no-unused-vars
Vue.config.errorHandler = (err, vm, info) => {
  vm.$rollbar.error(err)
  throw err // rethrow
}

Vue.config.productionTip = false

const mount = async () => {
  const i18n = await initI18n(store)

  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App),
  }).$mount('#app')
}

mount()

const dispatchWindowHeightEvent = () => {
  const event = new CustomEvent('minerva-height', {
    bubbles: true,
    detail: {
      height: window.innerHeight,
    },
  })
  document.dispatchEvent(event)
}

dispatchWindowHeightEvent()

window.addEventListener('resize', dispatchWindowHeightEvent)
